// extracted by mini-css-extract-plugin
export default {"label":"upload-button_label__GiIMT"};